(() => {
  const homeHero = document.querySelector('.nh-home-hero');
  if (!homeHero) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const html = document.documentElement;

  const sectionSelector = [
    '.nh-reviews',
    '.nh-featured-collection',
    '.nh-logo-proof',
    '.nh-before-after',
    '.nh-comparison',
    '.nh-reference-benefits',
    '.nh-simple-steps',
    '.nh-guarantees',
    '.nh-education',
    '.nh-press',
    '.nh-benefits',
    '.nh-lifestyle',
    '.nh-proof',
    '.nh-dedication',
    '.nh-ugc',
    '.nh-story__row',
    '.nh-faq',
    '.nh-final-cta',
    '.godmains--newsletterss',
    '.custom--iconsfooter'
  ].join(',');

  const itemSelector = [
    '.nh-section-heading > *',
    '.nh-reviews__summary',
    '.nh-reviews__intro > *',
    '.nh-review-card',
    '.nh-featured-collection .collection__title > *',
    '.nh-featured-collection .grid__item',
    '.nh-logo-proof__heading',
    '.nh-before-after__card',
    '.nh-comparison__row',
    '.nh-reference-benefit',
    '.nh-simple-step',
    '.nh-guarantee-card',
    '.nh-feature-list > li',
    '.nh-press__grid img',
    '.nh-benefit-card',
    '.nh-trust-card',
    '.nh-ugc-card',
    '.nh-story__content > *',
    '.nh-story__benefits > li',
    '.nh-faq .accordion',
    '.nh-newsletter-copy > *',
    '.nh-newsletter-form',
    '.custom--iconsfooter .col-sm-3'
  ].join(',');

  const surfaceSelector = [
    '.nh-review-card',
    '.nh-featured-collection .card-wrapper',
    '.nh-before-after__card',
    '.nh-reference-benefit',
    '.nh-guarantee-card',
    '.nh-benefit-card',
    '.nh-ugc-card',
    '.nh-faq .accordion',
    '.custom--iconsfooter .content--footer'
  ].join(',');

  const buttonSelector = [
    '.nh-button',
    '.nh-header__cta',
    '.nh-featured-collection .button',
    '.nh-featured-collection .quick-add__submit',
    '.nh-card-view-details a',
    '.nh-newsletter-submit',
    '.nh-final-cta a'
  ].join(',');

  const depthSelector = [
    '.nh-home-hero__media',
    '.nh-before-after__media img',
    '.nh-split__media > img',
    '.nh-proof__media img',
    '.nh-story__media img',
    '.nh-final-cta__image'
  ].join(',');

  html.classList.add('nh-motion-ready');

  let revealObserver;
  let depthItems = [];
  let depthFrame = 0;

  const createProgress = () => {
    if (reduceMotion || document.querySelector('.nh-scroll-progress')) return;
    const progress = document.createElement('div');
    progress.className = 'nh-scroll-progress';
    progress.setAttribute('aria-hidden', 'true');
    document.body.appendChild(progress);
  };

  const updateProgress = () => {
    const progress = document.querySelector('.nh-scroll-progress');
    if (!progress) return;
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    const ratio = scrollable > 0 ? Math.min(Math.max(window.scrollY / scrollable, 0), 1) : 0;
    progress.style.setProperty('--nh-scroll-progress', ratio.toFixed(4));
  };

  const updateDepth = () => {
    depthFrame = 0;
    if (reduceMotion || window.innerWidth < 750) return;

    const viewportCenter = window.innerHeight / 2;
    depthItems.forEach((item) => {
      if (!item.isConnected) return;
      const rect = item.getBoundingClientRect();
      if (rect.bottom < -100 || rect.top > window.innerHeight + 100) return;
      const center = rect.top + rect.height / 2;
      const distance = (center - viewportCenter) / window.innerHeight;
      const offset = Math.max(-1, Math.min(1, distance)) * -12;
      item.style.setProperty('--nh-depth-y', `${offset.toFixed(2)}px`);
    });
  };

  const requestMotionFrame = () => {
    updateProgress();
    if (!depthFrame) depthFrame = window.requestAnimationFrame(updateDepth);
    document.body.classList.toggle('nh-page-scrolled', window.scrollY > 24);
  };

  const prepareReveals = (root = document) => {
    root.querySelectorAll(sectionSelector).forEach((section) => {
      if (section.dataset.nhMotionReady) return;
      section.dataset.nhMotionReady = 'true';
      section.classList.add('nh-reveal');

      section.querySelectorAll(itemSelector).forEach((item, index) => {
        item.classList.add('nh-motion-item');
        item.style.setProperty('--nh-delay', `${Math.min(index, 10) * 62}ms`);
        item.style.setProperty('--nh-motion-x', `${index % 2 === 0 ? -10 : 10}px`);
      });

      if (reduceMotion || !revealObserver) {
        section.classList.add('nh-reveal--visible');
      } else {
        revealObserver.observe(section);
      }
    });
  };

  const prepareSurfaces = (root = document) => {
    if (reduceMotion || !finePointer) return;
    root.querySelectorAll(surfaceSelector).forEach((surface) => {
      if (surface.dataset.nhSurfaceReady) return;
      surface.dataset.nhSurfaceReady = 'true';
      surface.classList.add('nh-motion-surface');

      surface.addEventListener('pointermove', (event) => {
        const rect = surface.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
        surface.style.setProperty('--nh-pointer-x', `${x.toFixed(2)}%`);
        surface.style.setProperty('--nh-pointer-y', `${y.toFixed(2)}%`);
        surface.classList.add('nh-pointer-active');
      });
      surface.addEventListener('pointerleave', () => surface.classList.remove('nh-pointer-active'));
    });
  };

  const prepareButtons = (root = document) => {
    if (reduceMotion || !finePointer) return;
    root.querySelectorAll(buttonSelector).forEach((button) => {
      if (button.dataset.nhMagneticReady) return;
      button.dataset.nhMagneticReady = 'true';
      button.classList.add('nh-magnetic');

      button.addEventListener('pointermove', (event) => {
        const rect = button.getBoundingClientRect();
        const x = (event.clientX - rect.left - rect.width / 2) * 0.12;
        const y = (event.clientY - rect.top - rect.height / 2) * 0.16;
        button.style.setProperty('--nh-magnetic-x', `${x.toFixed(2)}px`);
        button.style.setProperty('--nh-magnetic-y', `${y.toFixed(2)}px`);
      });
      button.addEventListener('pointerleave', () => {
        button.style.setProperty('--nh-magnetic-x', '0px');
        button.style.setProperty('--nh-magnetic-y', '0px');
      });
    });
  };

  const prepareDepth = (root = document) => {
    if (reduceMotion) return;
    root.querySelectorAll(depthSelector).forEach((item) => {
      if (item.dataset.nhDepthReady) return;
      item.dataset.nhDepthReady = 'true';
      item.classList.add('nh-depth-layer');
      depthItems.push(item);
    });
    updateDepth();
  };

  const pauseOtherVideos = (activeVideo) => {
    document.querySelectorAll('.nh-ugc-card__video').forEach((video) => {
      if (video !== activeVideo && !video.paused) video.pause();
    });
  };

  const prepareVideos = (root = document) => {
    root.querySelectorAll('.nh-ugc-card').forEach((card) => {
      if (card.dataset.nhVideoReady) return;
      const video = card.querySelector('.nh-ugc-card__video');
      const button = card.querySelector('.nh-ugc-card__play');
      if (!video || !button) return;
      card.dataset.nhVideoReady = 'true';

      const syncState = () => {
        const isPlaying = !video.paused && !video.ended;
        card.classList.toggle('is-playing', isPlaying);
        button.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
        button.setAttribute('aria-label', isPlaying ? 'Pause testimonial video' : 'Play testimonial video');
        const icon = button.querySelector('span');
        if (icon) icon.textContent = isPlaying ? '\u23F8' : '\u25B6';
      };

      const toggleVideo = () => {
        if (video.paused || video.ended) {
          pauseOtherVideos(video);
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      };

      button.addEventListener('click', toggleVideo);
      video.addEventListener('click', toggleVideo);
      video.addEventListener('play', syncState);
      video.addEventListener('pause', syncState);
      video.addEventListener('ended', syncState);
      syncState();
    });
  };

  const prepareReviewMarquees = (root = document) => {
    root.querySelectorAll('.nh-reviews__grid').forEach((track) => {
      if (track.nhReviewTicker) {
        track.nhReviewTicker.start();
        return;
      }

      let frame = 0;
      let lastTime = 0;
      let offset = 0;
      let speed = 0.035;

      const readDuration = () => {
        const raw = getComputedStyle(track).getPropertyValue('--nh-reviews-marquee-duration').trim();
        const seconds = Number.parseFloat(raw);
        return Number.isFinite(seconds) && seconds > 0 ? seconds : 56;
      };

      const cardStep = () => {
        const first = track.querySelector('.nh-review-card');
        if (!first) return 0;

        const second = first.nextElementSibling;
        if (second) {
          const distance = second.getBoundingClientRect().left - first.getBoundingClientRect().left;
          if (distance > 0) return distance;
        }

        const gap = Number.parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return first.getBoundingClientRect().width + gap;
      };

      const syncSpeed = () => {
        const originals = track.querySelectorAll('.nh-review-card:not(.nh-review-card--clone)');
        const distance = Array.from(originals).reduce((total, card, index) => {
          if (index === originals.length - 1) return total + card.getBoundingClientRect().width;
          const next = originals[index + 1];
          return total + Math.max(next.getBoundingClientRect().left - card.getBoundingClientRect().left, card.getBoundingClientRect().width);
        }, 0);

        speed = Math.max(0.018, distance / (readDuration() * 1000));
      };

      let paused = false;

      const stop = () => {
        if (frame) window.cancelAnimationFrame(frame);
        frame = 0;
        lastTime = 0;
        offset = 0;
        track.classList.remove('nh-reviews__grid--js');
        track.style.removeProperty('--nh-reviews-ticker-x');
      };

      const tick = (time) => {
        if (paused) {
          frame = window.requestAnimationFrame(tick);
          return;
        }
        if (!lastTime) lastTime = time;
        const delta = Math.min(time - lastTime, 48);
        lastTime = time;

        offset -= speed * delta;

        let step = cardStep();
        while (step > 0 && Math.abs(offset) >= step) {
          const first = track.querySelector('.nh-review-card');
          if (!first) break;
          track.appendChild(first);
          offset += step;
          step = cardStep();
        }

        track.style.setProperty('--nh-reviews-ticker-x', `${offset.toFixed(2)}px`);
        frame = window.requestAnimationFrame(tick);
      };

      const start = () => {
        if (window.innerWidth >= 750 || reduceMotion) {
          stop();
          return;
        }

        track.classList.add('nh-reviews__grid--js');
        syncSpeed();

        if (!frame) frame = window.requestAnimationFrame(tick);
      };

      track.addEventListener('touchstart', (e) => {
        paused = true;
        lastTime = 0;
      }, { passive: true });

      track.addEventListener('touchend', () => {
        paused = false;
        lastTime = 0;
      }, { passive: true });

      track.addEventListener('touchcancel', () => {
        paused = false;
        lastTime = 0;
      }, { passive: true });

      track.nhReviewTicker = { start, stop };

      window.addEventListener('resize', start, { passive: true });
      window.addEventListener('orientationchange', () => window.requestAnimationFrame(start), { passive: true });
      window.addEventListener('load', start, { once: true });

      window.requestAnimationFrame(start);
    });
  };

  const prepare = (root = document) => {
    prepareReveals(root);
    prepareSurfaces(root);
    prepareButtons(root);
    prepareDepth(root);
    prepareVideos(root);
    prepareReviewMarquees(root);
  };

  if ('IntersectionObserver' in window && !reduceMotion) {
    revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('nh-reveal--visible');
          revealObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -8% 0px' }
    );
  }

  const initialize = () => {
    createProgress();
    prepare();
    window.requestAnimationFrame(() => {
      homeHero.classList.add('nh-home-intro-ready');
      requestMotionFrame();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  window.addEventListener('scroll', requestMotionFrame, { passive: true });
  window.addEventListener('resize', requestMotionFrame, { passive: true });
  document.addEventListener('shopify:section:load', (event) => {
    prepare(event.target);
    requestMotionFrame();
  });
})();
